import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import { IGetModifierGroupsShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { Select } from 'antd';
import { getModifierGroupsShortByRestaurantId } from 'backend/modifierGroups';
import style from './ModifierGroupSelect.module.scss';

const { Option } = Select;

export const ModifierGroupSelect: React.FC = () => {
	const { setIDModifierGroup, IDSelectedRestaurant, IDSelectedModifierGroup } =
		useContext<IModifiersContext>(ModifiersContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetModifierGroupsShortResponse, string>(
		IDSelectedRestaurant ? getModifierGroupsShortByRestaurantId : null,
		IDSelectedRestaurant || '',
	);
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedRestaurant]);

	const value = IDSelectedRestaurant && !loading ? IDSelectedModifierGroup : undefined;

	return (
		<div className={style.container} data-test="ModifierGroupSelect">
			<Text translationNameSpace="listing" translationKey="modifierGroupLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDModifierGroup}
				value={value}
				loading={loading}
				disabled={!IDSelectedRestaurant || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				listItemHeight={response?.data.modifierGroups.length}
				allowClear={true}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.modifierGroups.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response?.data.modifierGroups.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};
